import Image from 'next/image';
import Link from 'next/link';
// import { RoughNotation } from 'react-rough-notation';
import { useTranslation } from 'next-i18next';

const About = () => {
  const { t } = useTranslation('about');

  return (
    <>
      <div className="fade-in divide-y-2 divide-gray-100 dark:divide-gray-800">
        <div className="space-y-2 pt-6 pb-8 md:space-y-5">
          <h1 className="text-3xl font-extrabold leading-9 tracking-tight text-gray-900 dark:text-gray-100 sm:text-4xl sm:leading-10 md:text-6xl md:leading-14">
            {t('h1.about')}
          </h1>
          {/* {subtitle && (
            <p className="text-lg leading-7 text-gray-500 dark:text-gray-400">
              {subtitle}
            </p>
          )} */}
          {/* {children} */}
        </div>
        <div className="items-start space-y-2 xl:grid xl:grid-cols-3 xl:gap-x-8 xl:space-y-0">
          <div className="flex flex-col items-center space-x-2 pt-8">
            <Image
              src="https://scontent-cdg2-1.xx.fbcdn.net/v/t1.18169-1/13903284_1159271790762315_431699843878486082_n.jpg?stp=dst-jpg_p480x480&_nc_cat=102&ccb=1-7&_nc_sid=7206a8&_nc_ohc=1FuICgLAfhUAX_UN6Ry&_nc_ht=scontent-cdg2-1.xx&oh=00_AfDVAntv9UJw10V6Ts0LqYhmPvDPc5iKC8F-PJ5DV-n8kA&oe=639E954E"
              alt="avatar"
              width="192"
              height="192"
              className="h-48 w-48 rounded-full"
            />
            <h3 className="pt-4 pb-2 text-2xl font-bold leading-8 tracking-tight">
              {t('h3.fullname')}
            </h3>
            <div className="font-medium text-gray-500 dark:text-gray-400">
              {t('about.position')}
            </div>
            <div className="text-gray-500 dark:text-gray-400">
              {t('about.company')}
            </div>
          </div>

          <div className="prose max-w-none pt-8 pb-8 dark:prose-dark xl:col-span-2">
            <p>{t('introduction.paragraph1')}</p>
            <br />
            <p>{t('introduction.paragraph2')}</p>
            <br />
            {/* <p>{t('introduction.paragraph3')}</p>
            <br /> */}
            <p>
              {t('introduction.paragraph4')}
              {/* TODO: replace href with href="/contact" */}
              <Link className="ml-2 mr-2 font-normal text-black" href="/">
                <u>{t('introduction.weshouldtalk')}</u>
              </Link>
            </p>
            <p className="mt-8">
              {/* <a
                className="!font-normal !text-black !no-underline dark:!text-white"
                href="https://scontent-cdg2-1.xx.fbcdn.net/v/t1.18169-1/13903284_1159271790762315_431699843878486082_n.jpg?stp=dst-jpg_p480x480&_nc_cat=102&ccb=1-7&_nc_sid=7206a8&_nc_ohc=1FuICgLAfhUAX_UN6Ry&_nc_ht=scontent-cdg2-1.xx&oh=00_AfDVAntv9UJw10V6Ts0LqYhmPvDPc5iKC8F-PJ5DV-n8kA&oe=639E954E"
                target="_blank"
                rel="noreferrer"
              >
                <RoughNotation
                  show
                  type="box"
                  animationDelay={250}
                  animationDuration={2000}
                  strokeWidth={2}
                  color="#e5e5e5"
                >
                  Resume
                </RoughNotation>
              </a> */}
              {/* <h2 className="mt-8 mb-4 text-2xl font-semibold dark:text-white">
                Skills
              </h2>
              <StackList stack={WorkStack} /> */}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
